import React, { forwardRef } from 'react'
import { CloseIcon } from 'src/editor/shared/icons/close-icon'
import { CommonButton, CommonButtonProps } from './common-button'
import { ButtonSizeEnum, ButtonTypeEnum } from './enums'
import { twMerge } from 'tailwind-merge'

export interface CloseButtonProps
  extends Omit<
    CommonButtonProps,
    'type' | 'iconBefore' | 'iconAfter' | 'children' | 'icon'
  > {}

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ className, ...props }, ref) => (
    <CommonButton
      ref={ref}
      className={twMerge('[&>svg]:h-3 [&>svg]:w-3', className)}
      type={ButtonTypeEnum.Ghost}
      size={ButtonSizeEnum.Small}
      icon={<CloseIcon />}
      {...props}
    />
  ),
)
